module.exports = __webpack_public_path__ + "static/img/download_landing_ally_show.06ff1b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/images/download/download_landing_ally_show.jpg
// module id = X8LZ
// module chunks = 0